import Image from "next/image";
import { SanitizedContent } from "@/common/components-2/sanitized-content";
import { isNil } from "@/common/helpers/lang";
import { getBioClass, getBioItemClass, getHeadingClass } from "./bio.styles";
import type { BioProps } from "./bio.types";

export function Bio({ className, bios, heading, ...props }: BioProps) {
  return (
    <>
      {isNil(heading) ? null : <h2 className={getHeadingClass()}>{heading}</h2>}
      <div className={getBioClass({ className })} {...props}>
        {bios.map(({ bio, label }) => (
          <div key={`bio-${bio.name}-${label}`} className={getBioItemClass()}>
            <div className="top-6 size-12 shrink-0 max-lg:absolute lg:size-[75px]">
              <Image
                src={bio.photo.url}
                alt={bio.name}
                width={75}
                height={75}
                className="size-full rounded-full object-cover"
              />
            </div>
            <div className="flex flex-col gap-3 pt-4 lg:gap-6">
              <div className="flex flex-col max-lg:pl-16">
                <p className="text-gray-500 text-xs lg:text-sm">{label}</p>
                <h4 className="font-bold text-sm text-tertiary-600 lg:text-lg">
                  {bio.prefix} {bio.name}
                </h4>
              </div>
              <SanitizedContent as="div" content={bio.description} className="lg:text-xl lg:leading-relaxed" />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
